var TestIds;
(function (TestIds) {
    TestIds["INFORM_EMAIL_ERRORS_CONTENT"] = "INFORM_EMAIL_ERRORS_CONTENT";
    TestIds["INFORM_EMAIL_ERRORS_INVITE_ERROR_CONTENT"] = "INFORM_EMAIL_ERRORS_INVITE_ERROR_CONTENT";
    TestIds["INFORM_EMAIL_ERRORS_INVITE_ERROR_EMAILS"] = "INFORM_EMAIL_ERRORS_INVITE_ERROR_EMAILS";
    TestIds["INFORM_EMAIL_ERRORS_ADD_TO_GROUP_ERROR_CONTENT"] = "INFORM_EMAIL_ERRORS_ADD_TO_GROUP_ERROR_CONTENT";
    TestIds["INFORM_EMAIL_ERRORS_ADD_TO_GROUP_ERROR_EMAILS"] = "INFORM_EMAIL_ERRORS_ADD_TO_GROUP_ERROR_EMAILS";
    TestIds["EMAILS_TEXT_FIELD_ERROR"] = "EMAILS_TEXT_FIELD_ERROR";
    TestIds["MODAL_FOOTER_BUTTON_PRIMARY"] = "MODAL_FOOTER_BUTTON_PRIMARY";
})(TestIds || (TestIds = {}));
export default TestIds;
